import Enumerator from '../global/Enumerator';

export const labelTypes = ['ticket', 'contact', 'job', 'note', 'file'];

export class LabelType extends Enumerator {
  static default() {
    return this.of('ticket');
  }
}
LabelType.initEnum({
  ticket: {
    get title() {
      return 'Deal';
    },
    get weight() {
      return 1;
    }
  },
  contact: {
    get title() {
      return 'Contact';
    },
    get weight() {
      return 2;
    }
  },
  job: {
    get title() {
      return 'Task';
    },
    get weight() {
      return 3;
    }
  },
  note: {
    get title() {
      return 'Note';
    },
    get weight() {
      return 4;
    }
  },
  file: {
    get title() {
      return 'File';
    },
    get weight() {
      return 5;
    }
  }
});

export default {
  labelTypes,
  LabelType
};
